import React from 'react'
import EmployeeRegister from '../../components/EmployeeRegister'

const ScreenEmployeeRegister = ({ match }) => (
    <EmployeeRegister token={match.params.token} />
);

export default ScreenEmployeeRegister;